import { useResizeDetector } from 'react-resize-detector';

import * as styles from '../../../Navbar.css';

interface DropdownContentProps {
  children: React.ReactNode;
  open: boolean;
}

export function DropdownContent({ children, open }: DropdownContentProps) {
  const { height: contentHeight, ref: contentRef } = useResizeDetector({
    refreshMode: 'debounce',
    refreshRate: 100,
  });

  return (
    <div
      className={styles.navbarItemDropdownContentContainerV2}
      style={{
        maxHeight: open ? contentHeight : '0px',
        height: open ? contentHeight : '0px',
        opacity: open ? 1 : 0,
        overflow: open ? 'unset' : 'hidden',
      }}
    >
      <div ref={contentRef}>{children}</div>
    </div>
  );
}
